import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarIcon, X } from "lucide-react";
import { format, parseISO } from "date-fns";

export default function DatePicker({ value, onChange, placeholder = "Pick a date", testId }) {
  const date = value ? parseISO(value) : null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-md bg-white/5 border border-white/10 hover:border-white/20 text-left text-sm"
        >
          <CalendarIcon size={14} className="text-white/50" />
          <span className={date ? "text-white/90" : "text-white/40"}>
            {date ? format(date, "MMM d, yyyy") : placeholder}
          </span>
          {date && (
            <span
              role="button"
              tabIndex={0}
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              className="ml-auto text-white/40 hover:text-white cursor-pointer"
            >
              <X size={13} />
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 bg-[color:var(--surface)] border-white/10" align="start">
        <Calendar
          mode="single"
          selected={date || undefined}
          onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
